module.exports = __webpack_public_path__ + "static/morrisonfoerster-a7b728b29175b2b280244291a45b6bef.jpg";